export default dateIsoString => {
  const date = new Date(dateIsoString);
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  const hour = date.getHours();
  const minutes = date.getMinutes();
  const formattedCreationTime = `${day}/${month}/${year} ${hour}:${minutes}`;
  return formattedCreationTime;
};



// WEBPACK FOOTER //
// ../utils/functions/format-date.js